import { Component } from "react";
import { connect } from "react-redux";
import { getSigleCurrency } from "../../store/actions/singleCurrencyActions";

class PriceComp extends Component {
  componentDidMount() {
    let user = JSON.parse(localStorage.getItem("O_Auth"));
    this.props.getSigleCurrency(user ? user.currency : 1);
  }

  priceCalculation = price => {
    let { code, value } = this.props.singleCurrency;
    return this._code(code) + " " + this._price(price, value);
  };

  _price = (price, value) => {
    return (price /= value).toFixed(2);
  };

  _code = code => {
    if (code === "INR") {
      code = "₹";
    }
    if (code === "EUR") {
      code = "€";
    }
    return code;
  };

  render() {
    return this.priceCalculation(this.props.price);
  }
}

const mapStateToProps = state => {
  return {
    singleCurrency: state.singleCurrency.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getSigleCurrency: id => dispatch(getSigleCurrency(id))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PriceComp);
